import { A02, A02Input, A02Output } from 'api/U015';
import { useCallback, useState } from 'react';

type GetConsentDoRequest = (param?: {
  onSuccess?: (response: A02Output) => void;
  onError?: (err: Error) => void;
  cancellation?: AbortSignal;
}) => void;

export function useLazyGetConsentHooks(
  input: A02Input
): [A02Output | undefined, boolean, Error | null, GetConsentDoRequest] {
  const [loading, setLoading] = useState<boolean>(false);
  const [consent, setConsent] = useState<A02Output>();
  const [err, setError] = useState<Error | null>(null);

  const getConsent = async (cancellation: AbortSignal) => {
    return await A02(input, cancellation);
  };

  const doRequest = useCallback<GetConsentDoRequest>(
    async ({ cancellation, onSuccess, onError } = {}) => {
      const controller = new AbortController();
      const cancelSignal = cancellation ?? controller.signal;
      try {
        setLoading(true);
        const result = await getConsent(cancelSignal);
        setConsent(result);
        onSuccess?.(result);
      } catch (err) {
        console.error(err);
        const flooredError = err instanceof Error ? err : new Error(`unknown error. ${err}`);
        setError(flooredError);
        onError?.(flooredError);
      } finally {
        setLoading(false);
      }
    },
    [input]
  );

  return [consent, loading, err, doRequest];
}
